import React from "react";
import Link, { LinkProps } from "next/link";

import { useCountry, useLanguage } from "hooks";
import { buildLocalizedUrl } from "helpers";

export type LinkWithLocaleProps = LinkProps;

export const LinkWithLocale: React.FC<LinkWithLocaleProps> = ({
  children,
  href,
  ...rest
}) => {
  const country = useCountry();
  const language = useLanguage();

  if (typeof href === "string" && href.startsWith("http")) {
    return (
      <Link href={href} {...rest}>
        {children}
      </Link>
    );
  }

  const localizedHref = buildLocalizedUrl(href, country, language);

  return (
    <Link href={localizedHref} {...rest}>
      {children}
    </Link>
  );
};

export default LinkWithLocale;
